import type { ThemedBaseButtonProp } from './base-button.type';
import type { ButtonAdditionalEffectsSettings } from '@components/sp-button-additional-effects-settings/type/button-additional-effects-settings.type';
import type { ButtonIcon } from '@components/sp-button-icon/type/button-icon.type';

import {
    EButtonStyleType,
    EButtonHoverType,
    ESize,
    EButtonAdditionalEffectsCondition,
    EButtonAdditionalHoverEffectsTypes,
    EButtonAdditionalStaticEffectsTypes,
    EHorizontalPosition,
} from '@common/enums';

import { buttonIconTemplates } from '@common/icons/button-icons';
// Defined in `@sites/entity-core` so the widget css-vars twins there can compose
// the same class strings; re-exported here for this file's existing consumers.
export {
    DEFAULT_BUTTON_CLASS,
    BUTTON_TYPE_CLASS_MAP,
    BUTTON_SIZE_CLASS_MAP,
} from '@sites/entity-core/src/widget/common/styles/button-classes';

export const DEFAULT_BUTTON_BASE: ThemedBaseButtonProp = {
    color: ['rgb(255,255,255)'],
    background: ['rgb(0,0,0)'],
    borderColor: ['rgb(0,0,0)'],
    borderWidth: 2,
    borderRadius: 8,
    borderStyle: 'solid',
};

export const DEFAULT_BUTTON_HOVER_STATES = {
    hoverType: EButtonHoverType.opacity,
    opacity: 80,
    shadow: 'none',
    color: ['rgb(255,255,255)'],
    background: ['rgb(22,117,242)'],
    borderColor: ['rgba(0,0,0,0)'],
};

export const DEFAULT_BUTTON_ADDITIONAL_EFFECTS: ButtonAdditionalEffectsSettings = {
    isActive: false,
    effectCondition: EButtonAdditionalEffectsCondition.hover,
    hoverEffects: EButtonAdditionalHoverEffectsTypes.bounce,
    staticEffects: EButtonAdditionalStaticEffectsTypes.shine,
};

export const DEFAULT_BUTTON_ICON: ButtonIcon = {
    isActive: false,
    icon: buttonIconTemplates.telegram,
    position: EHorizontalPosition.L,
};
